import FilterDatePicker from "components/FilterDatePicker";
import { startOfDay } from "date-fns";
import { useIntl } from "react-intl";

type EventStartDatePickerProps = {
  value?: Date;
  onChange: (value: Date | undefined) => void;
};

export default function EventStartDatePicker({
  value,
  onChange,
}: EventStartDatePickerProps) {
  const { formatMessage: t } = useIntl();
  const onChangeInternal = (date: Date | undefined) => {
    onChange(date ? startOfDay(date) : date);
  };

  return (
    <FilterDatePicker
      label={t({ id: "startDate" })}
      value={value}
      onChange={onChangeInternal}
    />
  );
}
